module.exports = __webpack_public_path__ + "static/media/OSTR01.b3468889.jpg";